import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const SmallBanner = () => {
  const data = useStaticQuery(graphql`
    {
      allMasonSectionContentCreative(
        filter: { meta: { name: { eq: "small_banner" } } }
        sort: {fields: updated_time, order: DESC}
        limit: 1
      ) {
        nodes {
          url
          meta {
            name
            url
          }
        }
      }
    }
  `)
  return (
    <div className="banner-small-wrap mt-4 h-auto md:h-96 rounded-none md:rounded-md overflow-hidden">
      {data.allMasonSectionContentCreative.nodes.map(card => (
        <div className="banner-img-wrap">
          <a target="_blank" href={card.meta.url !==null ? card.meta.url : "/"}>
            <img
              className="w-full h-full object-cover"
              src={card.url}
              alt="grid image"
            />
          </a>
        </div>
      ))}
    </div>
  )
}

export default SmallBanner
